export default {
  "leadConvertedAndMemberCreated": "Cliente potencial convertido y socio creado",
  "members": "Socios",
  "thisMemberDoesNotHaveAPhoneNumberOnFile": "Este socio no tiene un número de teléfono registrado.",
  "pleaseSelectAClubInstanceFromTheTopRightSwitcherToManageMembers": "Selecciona un club en el selector superior derecho para gestionar los socios.",
  "importMembers": "Importar socios",
  "addMember": "Añadir socio",
  "searchMembers": "Buscar socios...",
  "noMembersFound": "No se encontraron socios",
  "deleteMember": "Eliminar socio",
  "thisActionCannotBeUndone": "Esta acción no se puede deshacer",
  "areYouSureYouWantToDelete": "¿Seguro que quieres eliminar a",
  "thisWillPermanentlyRemoveTheirMembershipRecordAndAllAssociatedData": "? Se eliminarán permanentemente su registro de socio y todos los datos asociados.",
  "deleting": "Eliminando...",
  "describeTheMessageYouWantToSendAndILlWriteItForYouYouCanTypeOrUseYourVoice": "Describe el mensaje que quieres enviar y lo redactaré por ti. Puedes escribir o usar la voz.",
  "eGWriteAFriendlyFollowUpAboutTheMemberDinnerNextFridayAndAskIfTheyHaveAnyDietaryRestrictions": "Por ejemplo: «Escribe un seguimiento amable sobre la cena de socios del próximo viernes y pregunta si tienen restricciones alimentarias».",
  "stopListening": "Dejar de escuchar",
  "useVoice": "Usar voz",
  "generateMessage": "Generar mensaje",
  "member": "Socio",
  "sorryIWasUnableToGenerateAMessagePleaseTryAgain": "No se pudo generar un mensaje. Inténtalo de nuevo.",
  "makeCall": "Llamar",
  "contactMember": "Contactar con el socio",
  "failedToSendMessage": "No se pudo enviar el mensaje",
  "lead": "Cliente potencial",
  "message": "Mensaje",
  "willSendViaYourConnectedEmailProviderGmailOutlook": "Se enviará mediante tu proveedor de correo conectado (Gmail/Outlook)",
  "aiSuggestedReplies": "Respuestas sugeridas por IA",
  "generatingIdeas": "Generando ideas...",
  "messageSentSuccessfully": "¡Mensaje enviado correctamente!",
  "call": "Llamada",
  "loadingActivityHistory": "Cargando historial de actividad...",
  "noActivityHistoryRecordedYet": "Todavía no hay historial de actividad.",
  "activity": "Actividad",
  "reciprocalVisit": "Visita recíproca",
  "unknown": "Desconocido",
  "noSmsInteractionsYet": "Todavía no hay interacciones por SMS.",
  "noEmailInteractionsYet": "Todavía no hay interacciones por correo.",
  "noCallInteractionsYet": "Todavía no hay interacciones de llamadas.",
  "noInteractionsLoggedForThisMemberYet": "Todavía no se han registrado interacciones para este socio.",
  "openInSmsModule": "Abrir en el módulo SMS",
  "loadingMoreInteractions": "Cargando más interacciones...",
  "overdue": "Vencido",
  "annualDues": "Cuotas anuales:",
  "interactions": "Interacciones:",
  "activities": "Actividades:",
  "memberSince": "Antigüedad",
  "viewProfile": "Ver perfil",
  "callMember": "Llamar al socio",
  "editMember": "Editar socio",
  "spouse": "Cónyuge",
  "partner": "Pareja",
  "parent": "Progenitor",
  "sibling": "Hermano/a",
  "guardian": "Tutor/a",
  "other": "Otro",
  "unableToLoadProfileGroups": "No se pudieron cargar los grupos del perfil.",
  "vegetarian": "Vegetariano",
  "vegan": "Vegano",
  "pescatarian": "Pescetariano",
  "glutenFree": "Sin gluten",
  "dairyFree": "Sin lácteos",
  "halal": "Halal",
  "kosher": "Kosher",
  "nutAllergy": "Alergia a los frutos secos",
  "otherAllergy": "Otra alergia",
  "otherRequirement": "Otro requisito",
  "preferredTitle": "Tratamiento preferido",
  "firstName": "Nombre",
  "middleNames": "Otros nombres",
  "lastName": "Apellidos",
  "preferredName": "Nombre preferido",
  "gender": "Género",
  "dateOfBirth": "Fecha de nacimiento",
  "maritalStatus": "Estado civil",
  "anniversary": "Aniversario",
  "signInEmail": "Correo de acceso",
  "readOnlyAccountEmail": "Correo de la cuenta de solo lectura",
  "contactEmail": "Correo de contacto",
  "secondaryEmail": "Correo secundario",
  "mobile": "Móvil",
  "homeTelephone": "Teléfono particular",
  "workTelephone": "Teléfono del trabajo",
  "personal": "Personal",
  "profile": "Perfil",
  "contact": "Contacto",
  "addresses": "Direcciones",
  "emergency": "Emergencia",
  "family": "Familia",
  "dietary": "Alimentación",
  "vehicles": "Vehículos",
  "unableToLoadActivityDetails": "No se pudieron cargar los detalles de la actividad",
  "pleaseChooseAnInteractionType": "Selecciona un tipo de interacción.",
  "unableToSaveInteraction": "No se pudo guardar la interacción",
  "failedToAddInteraction": "No se pudo añadir la interacción",
  "backToMembers": "Volver a socios",
  "memberNotFound": "No se encontró al socio.",
  "golfBooking": "Reserva de golf",
  "racquetBooking": "Reserva de deportes de raqueta",
  "fitnessClass": "Clase de fitness",
  "spaBooking": "Reserva de spa",
  "reciprocalClubVisit": "Visita a club recíproco",
  "roomReservation": "Reserva de habitación",
  "eventAttendance": "Asistencia a evento",
  "activityDetails": "Detalles de la actividad",
  "unknownMember": "Socio desconocido",
  "viewProfilePicture": "Ver foto de perfil",
  "phone": "Teléfono",
  "membershipNumber": "Número de socio",
  "annualDues2": "Cuotas anuales",
  "weddingDate": "Fecha de boda",
  "anniversary2": "Aniversario:",
  "address": "Dirección",
  "emergencyContact": "Contacto de emergencia",
  "loadingFamilyMembers": "Cargando familiares...",
  "noLinkedFamilyMembers": "No hay familiares vinculados.",
  "boats": "Embarcaciones",
  "boat": "Embarcación",
  "horses": "Caballos",
  "horse": "Caballo",
  "sportLevels": "Niveles deportivos",
  "golfHcp": "Hándicap de golf",
  "tennisLevel": "Nivel de tenis",
  "padelLevel": "Nivel de pádel",
  "visualMemberProfileCards": "Tarjetas visuales del perfil del socio",
  "profileGroups": "Grupos del perfil",
  "loading": "Cargando…",
  "primaryPostal": "Dirección postal principal",
  "noAddressesRecorded": "No hay direcciones registradas.",
  "emergencyContact2": "Contacto de emergencia",
  "accepted": "• Aceptado",
  "memberConsentRequests": "Solicitudes de consentimiento del socio",
  "incomingToMember": "Entrantes al socio",
  "outgoingFromMember": "Salientes del socio",
  "removal": "Eliminación",
  "add": "Añadir",
  "noDietaryRequirementsRecorded": "No hay requisitos alimentarios registrados.",
  "primaryVehicle": "Vehículo principal",
  "noVehiclesRecorded": "No hay vehículos registrados.",
  "memberDetails": "Datos del socio",
  "crmLeadHistory": "Historial del cliente potencial de CRM",
  "achievementsHistory": "Logros / Historial",
  "interactions2": "Interacciones (",
  "activityHistory": "Historial de actividad (",
  "financial": "Finanzas",
  "memberInteractionHistory": "Historial de interacciones del socio",
  "completeRecordOfAllCommunicationsAndInteractions": "Registro completo de todas las comunicaciones e interacciones",
  "filter": "Filtrar",
  "allInteractions": "Todas las interacciones",
  "all": "Todas",
  "activityHistory2": "Historial de actividad",
  "loggedActivitiesForThisMember": "Actividades registradas de este socio",
  "bookingMemberName": "Nombre del socio de la reserva",
  "bookingMemberNumber": "Número del socio de la reserva",
  "service": "Servicio",
  "spaService": "Servicio de spa",
  "therapist": "Terapeuta",
  "notAssigned": "Sin asignar",
  "room": "Habitación",
  "destinationClub": "Club de destino",
  "reciprocalType": "Tipo de reciprocidad",
  "confirmationNumber": "Número de confirmación",
  "guests": "Invitados",
  "checkIn": "Entrada",
  "checkOut": "Salida",
  "event": "Evento",
  "attendees": "Asistentes",
  "weCouldnTMatchThisActivityToAKnownDetailModalYet": "Todavía no se pudieron vincular los detalles de esta actividad a un tipo conocido.",
  "title": "Título:",
  "occurredAt": "Fecha y hora:",
  "typeKey": "Clave del tipo:",
  "players": "Jugadores",
  "guest": "Invitado",
  "unknownPlayer": "Jugador desconocido",
  "hcp": "Hándicap:",
  "noPlayersRecorded": "No hay jugadores registrados.",
  "addOns": "Complementos",
  "addOn": "Complemento",
  "qty": "Cantidad:",
  "noAddOnsRecorded": "No hay complementos registrados.",
  "loadingTypes": "Cargando tipos…",
  "noMembershipTypesFound": "No se encontraron tipos de afiliación",
  "active": "Activo",
  "sortBy": "Ordenar por...",
  "newestFirst": "Más recientes primero",
  "nameAZ": "Nombre (A-Z)",
  "nameZA": "Nombre (Z-A)",
  "membershipAsc": "N.º de socio (ascendente)",
  "membershipDesc": "N.º de socio (descendente)",
  "mostInteractions": "Más interacciones",
  "mostActivities": "Más actividades",
  "inCreditBy": "Crédito de",
  "balanceDue": "Saldo pendiente",
  "noOverdueInvoices": "No hay facturas vencidas",
  "unableToLoadFinancialData": "No se pudieron cargar los datos financieros",
  "membershipDuesStatus": "Estado de las cuotas de afiliación",
  "readOnlyDuesStatusAndRecentBillingActivity": "Estado de cuotas y actividad de facturación reciente, de solo lectura.",
  "youDonTHavePermissionToViewMemberFinancials": "No tienes permiso para ver las finanzas del socio.",
  "currentDuesStatus": "Estado actual de las cuotas",
  "activeTemplate": "Plantilla activa",
  "notConfigured": "Sin configurar",
  "nextInvoiceDate": "Próxima fecha de factura",
  "outstandingDuesBalance": "Saldo pendiente de cuotas",
  "latestDuesInvoice": "Última factura de cuotas",
  "noDuesInvoiceYet": "Todavía no hay facturas de cuotas",
  "latestDuesInvoiceDue": "Vencimiento de la última factura de cuotas",
  "overdueDuesInvoices": "Facturas de cuotas vencidas",
  "recentDuesPayments": "Pagos recientes de cuotas",
  "financialSummary": "Resumen financiero",
  "memberNetPaidBalanceAndOverdueInsights": "Pagos netos, saldo y vencimientos del socio.",
  "netPaidYtd": "Pagos netos del año",
  "netPaidMtd": "Pagos netos del mes",
  "netPaidWtd": "Pagos netos de la semana",
  "netPaidToday": "Pagos netos de hoy",
  "balance": "Saldo",
  "latestOverdueInvoice": "Última factura vencida",
  "accountActivity": "Actividad de la cuenta",
  "canonicalMemberAccountChargesAndLedgerActivity": "Cargos de la cuenta del socio y actividad contable vinculada.",
  "noMemberAccountActivityFound": "No se encontró actividad en la cuenta del socio.",
  "date": "Fecha",
  "type": "Tipo",
  "notRecorded": "Sin registrar",
  "payments": "Pagos",
  "mostRecentPaymentsAndAllocations": "Pagos y asignaciones más recientes.",
  "noPaymentsFoundForThisMember": "No se encontraron pagos de este socio.",
  "paidAt": "Fecha de pago",
  "allocations": "Asignaciones",
  "allocation": "asignación",
  "noAllocations": "Sin asignaciones",
  "loadMore": "Cargar más",
  "unableToResolveClubForFamilyLinks": "No se pudo determinar el club para los vínculos familiares",
  "unableToResolveClubForMembershipTypes": "No se pudo determinar el club para los tipos de afiliación",
  "failedToLoadMembershipTypes": "No se pudieron cargar los tipos de afiliación",
  "unableToSearchMembers": "No se pudieron buscar socios",
  "unableToDetermineClubForUpload": "No se pudo determinar el club para la subida",
  "uploadFailed": "La subida ha fallado",
  "errorClubContextIsNotAvailableCannotSaveMember": "El contexto del club no está disponible. No se puede guardar el socio.",
  "pleaseProvideFirstNameLastNameEmailAndMembershipNumber": "Indica nombre, apellidos, correo y número de socio.",
  "phoneNumberIsRequired": "El número de teléfono es obligatorio",
  "pleaseEnterAValidPhoneNumberE164": "Introduce un número de teléfono válido (E.164)",
  "unableToUpdateMember": "No se pudo actualizar el socio",
  "unableToCreateMember": "No se pudo crear el socio",
  "failedToSaveMemberPleaseTryAgain": "No se pudo guardar el socio. Inténtalo de nuevo.",
  "areYouSureYouWantToDeleteThisMemberThisCannotBeUndone": "¿Seguro que quieres eliminar este socio? Esta acción no se puede deshacer.",
  "errorClubContextIsNotAvailableCannotDeleteMember": "El contexto del club no está disponible. No se puede eliminar el socio.",
  "unableToDeleteMember": "No se pudo eliminar el socio",
  "failedToDeleteMemberPleaseTryAgain": "No se pudo eliminar el socio. Inténtalo de nuevo.",
  "unableToAddFamilyLink": "No se pudo añadir el vínculo familiar",
  "unableToRemoveFamilyLink": "No se pudo eliminar el vínculo familiar",
  "addNewMember": "Añadir nuevo socio",
  "enterTheDetailsForTheClubMemberBelow": "Introduce los datos del socio del club a continuación.",
  "memberAvatar": "Avatar del socio",
  "uploading": "Subiendo...",
  "uploadPhoto": "Subir foto",
  "removePhoto": "Eliminar foto",
  "currentMembershipTerm": "Periodo de afiliación actual",
  "unspecified": "Sin especificar",
  "started": "Inicio",
  "renewal": "; renovación",
  "renewalDateOverrideOptional": "Fecha de renovación manual (opcional)",
  "firstName2": "Nombre",
  "lastName2": "Apellidos",
  "localNumber": "Número local",
  "enterMembershipNumber": "Introduce el número de socio",
  "joinDate": "Fecha de alta",
  "dateOfBirth2": "Fecha de nacimiento",
  "linkRelatedMembersWithinThisClub": "Vincula a socios relacionados dentro de este club.",
  "saveTheMemberFirstToAddFamilyLinks": "Guarda primero al socio para añadir vínculos familiares.",
  "searchMembers2": "Buscar socios",
  "typeANameOrMembershipNumber": "Escribe un nombre o número de socio",
  "noMembershipNumber": "Sin número de socio",
  "noMembersMatchThatSearch": "Ningún socio coincide con la búsqueda.",
  "relation": "Parentesco",
  "linkedMembers": "Socios vinculados",
  "remove": "Eliminar",
  "noFamilyMembersLinkedYet": "Todavía no hay familiares vinculados.",
  "deleteMember2": "Eliminar socio",
  "renewalDateOverride": "Fecha de renovación manual",
  "onlyCsvFilesAreSupportedForImportPleaseUploadACsvFile": "Solo se admiten archivos CSV para la importación. Sube un archivo .csv.",
  "currentClubContextIsMissingCannotImportMembersWithoutATenantId": "Falta el contexto del club. No se pueden importar socios sin un ID de club.",
  "chooseImportMethod": "Elegir método de importación",
  "uploadExistingFile": "Subir archivo existente",
  "uploadACsvFileWithYourMemberData": "Sube un archivo CSV con los datos de tus socios",
  "supportedFormatsCsv": "Formatos admitidos: CSV",
  "useOurTemplate": "Usar nuestra plantilla",
  "downloadAPreFormattedTemplateWithSampleData": "Descarga una plantilla con formato y datos de ejemplo",
  "downloadTemplate": "Descargar plantilla",
  "fillOutTheTemplateAndUploadItAbove": "Completa la plantilla y súbela arriba",
  "processingFile": "Procesando archivo...",
  "mapYourFields": "Asignar campos",
  "matchYourDataColumnsToPrivanaFieldsRequiredFieldsAreMarkedWith": "Asocia tus columnas a los campos de Privana. Los campos obligatorios se indican con *",
  "selectColumn": "Seleccionar columna...",
  "noMapping": "-- Sin asignación --",
  "back": "Atrás",
  "previewImport": "Vista previa de la importación",
  "reviewTheFirst5RowsOfYourMappedDataBeforeImporting": "Revisa las primeras 5 filas de los datos asignados antes de importar",
  "members2": "socios",
  "willBeImportedPleaseVerifyThePreviewDataLooksCorrectBeforeProceeding": "se importarán. Comprueba los datos de la vista previa antes de continuar.",
  "backToMapping": "Volver a la asignación",
  "startImport": "Iniciar importación",
  "importComplete": "Importación completada",
  "successfullyImported": "Importados correctamente",
  "failedToImport": "No se pudieron importar",
  "errors": "Errores:",
  "row": "Fila",
  "seeTheSalesInteractionsThatHappenedBeforeThisMemberJoined": "Consulta las interacciones comerciales anteriores al alta de este socio.",
  "loadingLeadHistory": "Cargando historial del cliente potencial…",
  "unableToLoadLeadHistoryForThisMember": "No se pudo cargar el historial del cliente potencial de este socio.",
  "originallyCapturedAsCrmLead": "Registrado inicialmente como cliente potencial de CRM.",
  "noCrmInteractionsWereLoggedForThisLead": "No se registraron interacciones de CRM para este cliente potencial.",
  "interaction": "Interacción",
  "name": "Nombre",
  "membership": "N.º de socio",
  "associateCallRecord": "Asociar registro de llamada",
  "multipleMembersMatchThePhoneNumberFromTheCallWith": "Varios socios coinciden con el número de teléfono de la llamada con",
  "unknownCaller": "Llamante desconocido",
  "pleaseSelectWhichMemberToLogThisActivityFor": ". Selecciona el socio para el que quieres registrar esta actividad.",
  "linkedCount": "{count} vinculados",
  "requiredMappings": "Asigna los siguientes campos obligatorios: {fields}",
  "dueInDays": "Vence en {count} días",
  "dueOn": "Vence el {date}",
  "years": "{count} años",
  "overdueDays": "Vencida hace {count} días",
  "holes": "{count} hoyos",
  "playersCount": "{count} jugadores",
  "onePlayer": "1 jugador",
  "parseFailed": "No se pudo analizar el CSV. Comprueba que cada fila tenga las mismas columnas que la cabecera.",
  "readFailed": "No se pudo leer el archivo. Inténtalo de nuevo.",
  "preparationFailed": "No se pudo preparar esta fila. Revisa los datos y vuelve a intentarlo.",
  "importFailed": "No se pudo completar la importación. Inténtalo de nuevo.",
  "tenure": "({years} años, {months} meses)",
  "importFields": {
    "first_name": "Nombre",
    "last_name": "Apellidos",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "membership_type": "Tipo de afiliación",
    "membership_number": "Número de socio",
    "membership_term_start": "Inicio del periodo de afiliación",
    "renewal_date_override": "Fecha de renovación manual",
    "joined_at": "Fecha de incorporación",
    "join_date": "Fecha de alta",
    "status": "Estado",
    "emergency_contact": "Contacto de emergencia",
    "address": "Dirección",
    "notes": "Notas",
    "membership_type_id": "ID del tipo de afiliación",
    "membership_type_name": "Nombre del tipo de afiliación",
    "date_of_birth": "Fecha de nacimiento"
  },
  "fieldTypes": {
    "text": "Texto",
    "email": "Correo",
    "select": "Opción",
    "date": "Fecha"
  },
  "child": "Hijo/a",
  "followUpPlaceholder": "Seguimiento desde el perfil de {name}",
  "loadMembersFailed": "No se pudieron cargar los socios. Inténtalo de nuevo.",
  "loadingMembers": "Cargando socios…",
  "smsRouting": {
    "inbound_member_priority_alpha": {
      "label": "Asignación automática: prioridad de socios",
      "tooltip": "Este número coincide con varias personas en Privana. El SMS entrante se asignó automáticamente a este socio mediante la regla alfabética que da prioridad a los socios."
    },
    "explicit_member": {
      "label": "Asignado: socio explícito",
      "tooltip": "Este SMS se envió desde el contexto de un socio y se asignó explícitamente a ese socio."
    },
    "explicit_lead": {
      "label": "Asignado: cliente potencial explícito",
      "tooltip": "Este SMS se envió desde el contexto de un cliente potencial y se asignó explícitamente a ese cliente potencial."
    },
    "single_match_member": {
      "label": "Asignado: único socio coincidente"
    },
    "single_match_lead": {
      "label": "Asignado: único cliente potencial coincidente"
    },
    "manual_outbound_selection": {
      "label": "Asignado: selección manual"
    }
  },
  "communicationUnableToLoadSmsSettings": "No se pudo cargar la configuración de SMS",
  "communicationPleaseEnterInstructionsForWhatYouWantToSay": "Introduce instrucciones sobre lo que quieres decir.",
  "communicationUnableToGenerateDraftsRightNowPleaseTryAgain": "No se pueden generar borradores ahora. Inténtalo de nuevo.",
  "communicationRoutingSaved": "Asignación guardada",
  "communicationSmsInteractionIsNowLinkedToTheSelectedPerson": "La interacción por SMS está vinculada a la persona seleccionada.",
  "communicationUnableToSaveRouting": "No se pudo guardar la asignación",
  "communicationMissingRecipientPhone": "Falta el teléfono del destinatario",
  "communicationSelectAFromNumber": "Selecciona un número de origen",
  "communicationPleaseChooseWhichClubNumberToSendFrom": "Elige desde qué número del club quieres enviar.",
  "communicationSmsBlocked": "SMS bloqueado",
  "communicationThisMemberHasOptedOutOfSms": "Este socio ha rechazado recibir SMS.",
  "communicationThisMemberHasNotConsentedToSms": "Este socio no ha dado su consentimiento para recibir SMS.",
  "communicationUnableToSendSmsAtThisTime": "No se puede enviar el SMS en este momento.",
  "communicationProviderDidNotAcceptTheMessagePleaseTryAgain": "El proveedor no aceptó el mensaje. Inténtalo de nuevo.",
  "communicationSmsSent": "SMS enviado",
  "communicationMessageSentChooseWhoThisSmsShouldBeLoggedAgainst": "Mensaje enviado. Elige a quién debe vincularse este SMS.",
  "communicationYourMessageIsOnItsWay": "Tu mensaje está en camino.",
  "communication160Characters": "/160 caracteres",
  "communicationFromNumber": "Número de origen",
  "communicationLoadingNumbers": "Cargando números...",
  "communicationSelectANumber": "Seleccionar un número",
  "communicationNoSmsEnabledClubNumbersAreAvailableEnableSmsForADidInAdminVoipNumbers": "No hay números del club habilitados para SMS. Habilita SMS para un número DID en Administración → Números VoIP.",
  "communicationDraftingAReply": "Redactando una respuesta...",
  "communicationSuggestedReply": "Respuesta sugerida",
  "communicationUseReply": "Usar respuesta",
  "communicationRegenerate": "Volver a generar",
  "communicationCouldnTDraftReply": "No se pudo redactar la respuesta.",
  "communicationWillSendViaTwilioSmsService": "Se enviará mediante el servicio de SMS de Twilio",
  "communicationThisNumberBelongsToMultiplePeopleInPrivanaWhoWasThisSmsIntendedFor": "Este número pertenece a varias personas en Privana. ¿A quién iba dirigido este SMS?",
  "communicationNoPhone": "Sin teléfono",
  "communicationNoRoutingCandidatesAvailable": "No hay candidatos para la asignación.",
  "communicationDescribeWhatYouWantToSendThenReviewAndEditTwoDraftSmsOptions": "Describe lo que quieres enviar y revisa y edita dos opciones de borrador de SMS.",
  "communicationInstruction": "Instrucción",
  "communicationExampleRemindThemTheirTourIsTomorrowAt10AmAndAskThemToReplyIfTheyNeedToReschedule": "Ejemplo: Recuerda que su visita es mañana a las 10:00 y pide que responda si necesita cambiarla.",
  "communicationGeneratingOptions": "Generando opciones...",
  "communicationGenerateOptions": "Generar opciones",
  "communicationOption1": "Opción 1",
  "communicationOption2": "Opción 2",
  "communicationUseThis": "Usar este",
  "communicationSmsThread": "Conversación SMS",
  "communicationViewAndReplyWithoutLeavingThisPage": "Consulta y responde sin salir de esta página.",
  "communicationUnableToLoadMessages": "No se pudieron cargar los mensajes.",
  "communicationLoadingMessages": "Cargando mensajes...",
  "communicationNoMessagesInThisConversationYet": "Todavía no hay mensajes en esta conversación.",
  "communicationConversation": "Conversación",
  "communicationScrollToViewAllMessages": "Desplázate para ver todos los mensajes",
  "communicationNewEmail": "Nuevo correo",
  "communicationAddAtLeastOneRecipientToForwardReply": "Añade al menos un destinatario para reenviar o responder.",
  "communicationMessageCannotBeEmpty": "El mensaje no puede estar vacío.",
  "communicationUnableToSendEmail": "No se pudo enviar el correo",
  "communicationPleaseTryAgainInAMoment": "Inténtalo de nuevo en un momento.",
  "communicationEmailSent": "Correo enviado",
  "communicationForwardSent": "Reenvío enviado",
  "communicationReplySent": "Respuesta enviada",
  "communicationDeliverySucceededMessageMetadataIsSyncing": "Enviado correctamente. Se están sincronizando los metadatos del mensaje.",
  "communicationMessageSent": "Mensaje enviado",
  "communicationSentSuccessfullyConversationRefreshIsStillSyncing": "Enviado correctamente. La conversación todavía se está sincronizando.",
  "communicationEmailThread": "Conversación de correo",
  "communicationLoadingConversation": "Cargando conversación…",
  "communicationComposeANewEmailToStartAConversation": "Redacta un correo nuevo para iniciar una conversación.",
  "communicationNoConversationMessagesAvailable": "No hay mensajes disponibles en la conversación.",
  "communicationYou": "Tú",
  "communicationUnknownSender": "Remitente desconocido",
  "communicationUnknownEmail": "Correo desconocido",
  "communicationHideCcBcc": "Ocultar CC/CCO",
  "communicationCcBcc": "CC/CCO",
  "communicationCc": "CC",
  "communicationBcc": "CCO",
  "communicationComposeEmail": "Redactar correo",
  "communicationComposeReply": "Redactar respuesta",
  "communicationTone": "Tono",
  "communicationBrief": "Breve",
  "communicationSyncingSent": "{status}. Sincronizando el elemento enviado…",
  "smsDelivery": {
    "queued": "En cola",
    "sending": "Enviando",
    "sent": "Enviado",
    "delivered": "Entregado",
    "failed": "Fallido",
    "undelivered": "No entregado",
    "scheduled": "Programado"
  },
  "player": "Jugador",
  "profileChoices": {
    "female": "Mujer",
    "male": "Hombre",
    "nonBinary": "No binario",
    "undisclosed": "Prefiero no indicarlo",
    "other": "Otro",
    "single": "Soltero/a",
    "married": "Casado/a",
    "civilPartnership": "Unión civil",
    "partnered": "En pareja",
    "separated": "Separado/a",
    "divorced": "Divorciado/a",
    "widowed": "Viudo/a"
  }
};
